module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/phone_app-876c5f02e110ffa51b20ba1614d6fbde.png";